import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

export const onInitTriggerLoadEdges = store.effects.create((feature: Feature) =>
  feature.actions.init.observe().pipe(
    rxjs.map(action => {
      const {
        data: {
          tree: { edgesFrom },
          widgetRefId,
        },
      } = action
      return feature.actions.loadEdges
        .from(action)
        .create({ chartId: models.Chart.Id.from(widgetRefId), edgesFrom })
    }),
  ),
)
